export default "__VITE_ASSET__654fe2f1__"